/*
 * @Description: 
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-01-18 11:27:47
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function initPageList(data) {
  const url = `/outSaleCostOrg/searchOutSaleCostOrgList`
  return http.post(url, data)
}

// 获取所有机构--育苗成本概览
export function getAllJiGou(rootId){
  const url = `/desktopReport/queryCostOrg/${rootId}`
  return http.get(url)
}

// 获取所有批次--育苗成本概览
export function getAllPiCi(rootId){
  const url = `/desktopReport/queryCostBatch/${rootId}`
  return http.get(url)
}
// 获取所有品类--育苗成本概览
export function getAllPinLei(rootId){
  const url = `/desktopReport/queryCostType/${rootId}`
  return http.get(url)
}
// 获取所有品种--育苗成本概览
export function getAllPinZhong(rootId){
  const url = `/desktopReport/queryCostBreed/${rootId}`
  return http.get(url)
}

